export enum Folder {
    INBOX = 'INBOX',
    ARCHIEF = 'ARCHIEF'
}

export enum Status {
    ONGELEZEN = 'ONGELEZEN',
    GELEZEN = 'GELEZEN',
    GEOPEND = 'GEOPEND',
    GEARCHIVEERD = 'GEARCHIVEERD',
    VERWIJDERD = 'VERWIJDERD'
}

export enum BerichtType {
    NIET_OPGEGEVEN = 'NIET_OPGEGEVEN',
    PRODUCTBERICHT_BETALEN = 'PRODUCTBERICHT_BETALEN',
    PRODUCTBERICHT_SPAREN = 'PRODUCTBERICHT_SPAREN',
    PRODUCTBERICHT_BELEGGEN = 'PRODUCTBERICHT_BELEGGEN',
    PRODUCTBERICHT_HYPOTHEKEN = 'PRODUCTBERICHT_HYPOTHEKEN',
    PRODUCTBERICHT_VERZEKERINGEN = 'PRODUCTBERICHT_VERZEKERINGEN',
    INFORMATIEBERICHT_BANK = 'INFORMATIEBERICHT_BANK',
    INFORMATIEBERICHT_MOBIELE_APP = 'INFORMATIEBERICHT_MOBIELE_APP',
    INFORMATIEBERICHT_RENTE_PERCENTAGE = 'INFORMATIEBERICHT_RENTE_PERCENTAGE',
    PERSOONLIJKE_TIP = 'PERSOONLIJKE_TIP',
    NIEUWSBERICHT = 'NIEUWSBERICHT'
}

export interface OffsetPage {
    page: number;
    size: number;
}

export interface BerichtInformatie {
    bericht_id: string;
    onderwerp: string;
    status: Status;
    map: Folder;
    aantal_keer_notificatie_tonen: number;
    aangemaakt_op: string;
    bericht_type: BerichtType;
    prioriteit: number;
}

export interface BerichtInformatiePagina extends OffsetPage {
    berichten_informatie: BerichtInformatie[];
}

export interface BerichtenPagina extends OffsetPage {
    berichten: Bericht[];
}

export interface Bericht {
    bericht_informatie: BerichtInformatie;
    inhoud: string;
}

export interface BerichtPatch {
    status: Status;
    map: Folder;
}
